import { css } from "@linaria/core"
import { Box, Stack, Typography } from "@mui/material"

import { TokenInfo } from "../../ao/token"
import { NumberFont, TitleFont } from "../../theme"
import { formatTicker } from "../../utils/format"
import TokenLogo from "../TokenLogo"
import { TokenPill } from "../TokenPill"

type RemoveOrderPreviewFormProps = {
  lpToken: TokenInfo
  lpAmount: string
  tokenA: TokenInfo
  tokenB: TokenInfo
}

export function RemoveOrderPreviewForm(props: RemoveOrderPreviewFormProps) {
  const { tokenA, tokenB, lpToken, lpAmount } = props

  return (
    <>
      <Typography variant="h5" fontFamily={TitleFont}>
        Withdraw Liquidity
      </Typography>
      <div
        className={css`
          padding-bottom: calc(var(--spacing) * 2);
          border-bottom: 1px solid var(--mui-palette-borderSecondary);
        `}
      >
        <Box
          sx={{
            "& > div": {
              marginBottom: 1,
              padding: 1,
              paddingX: 2,
            },
          }}
        >
          <TokenPill variant="outlined">
            <TokenLogo tx={tokenA?.logo} alt={`${tokenA?.name} logo`} size="small" />
            {formatTicker(tokenA?.ticker)}{" "}
            <Typography fontWeight={700} variant="subtitle1">
              /
            </Typography>
            <TokenLogo tx={tokenB?.logo} alt={`${tokenB?.name} logo`} size="small" />
            {formatTicker(tokenB?.ticker)}
          </TokenPill>
        </Box>
        {lpToken && (
          <Stack gap={1}>
            <Box sx={{ minHeight: 25 }}>
              <Typography
                variant="caption"
                sx={{
                  background: "var(--mui-palette-background-paper)",
                  borderRadius: 5,
                  paddingY: 0.25,
                  paddingX: 0.75,
                }}
                color="secondary"
              >
                {lpToken?.ticker}
              </Typography>
            </Box>
            <Typography
              fontFamily={NumberFont}
              variant="h3"
              sx={{
                textOverflow: "ellipsis",
                overflow: "hidden",
              }}
            >
              {lpAmount}
            </Typography>
          </Stack>
        )}
      </div>
    </>
  )
}
